import CustomLink from './CustomLink.component';

export default CustomLink;
